import { BillLineItemV2Kind, BillLineProcessingV2 } from '@types'
import { MockFactory } from '@tino-frontend/mocks'

export const lineItemProcessingPurchaseMock =
  new MockFactory<BillLineProcessingV2>({
    id: 'processing_id_1',
    amount_cents: 30000,
    reference_date: '2022-05-15T00:00:00Z',
    payer_id: 'payer_id_02',
    kind: BillLineItemV2Kind.Reservation,
    metadata: {
      supplier_name: 'LojaExemplo',
      reservation_created_at: '2022-01-01T00:00:00Z',
    },
  })
